import baseStyled, {
    ThemedStyledInterface,
    useTheme as useBaseTheme,
    css as baseCss,
    ThemedCssFunction,
    ThemeProvider as BaseThemeProvider,
    ThemeProviderComponent,
    CSSObject,
    CSSProp,
    keyframes as baseKeyframes,
} from 'styled-components'
import { Theme } from '.'

const styled = baseStyled as ThemedStyledInterface<Theme>
export const useTheme = useBaseTheme as () => Theme
export const css = baseCss as ThemedCssFunction<Theme>
export const keyframes = baseKeyframes
export type { CSSObject, CSSProp }

export default styled

export const ThemeProvider = BaseThemeProvider as ThemeProviderComponent<Theme>
